// extracted by mini-css-extract-plugin
export var centerText = "_5n-8";
export var container = "_5n-0";
export var doughnutContainer = "_5n-7";
export var legend = "_5n-a";
export var legendItemColorDisplay = "_5n-b";
export var legendItemLabel = "_5n-d";
export var legendItemValue = "_5n-c";
export var lg = "_5n-5";
export var maxWidth = "_5n-9";
export var md = "_5n-4";
export var responsive = "_5n-6";
export var sm = "_5n-3";
export var xs = "_5n-2";
export var xxs = "_5n-1";